import React from 'react';
import { chatAxios_get } from '../context/SnpChatNetworkUtils';
import { CHAT_IMAGE_URL } from '../utils/SnpChatConstant';

function PhotoView({ imageUrl = "", onDismiss = () => { } }) {


    const handleDownload = async () => {
        try {
            const response = await chatAxios_get(
                `chat-images/${imageUrl}`,
                { responseType: 'blob' }
            );
            if (response) {
                const blobUrl = window.URL.createObjectURL(response);

                const link = document.createElement('a');
                link.href = blobUrl;

                // Dynamic filename from the original image URL
                const fileName = imageUrl.split('/').pop()?.split('?')[0] || 'downloaded-image.jpg';
                link.download = fileName;

                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                window.URL.revokeObjectURL(blobUrl);
            } else {
                console.error("ChatContext:Download failed: response is empty");
            }
        } catch (error) {
            console.error("ChatContext:Download failed:", error);
        }
    };

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.85)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                zIndex: 1000,
            }}
        >
            <div
                style={{
                    position: 'relative',
                    maxWidth: '85%',
                    maxHeight: '85%',
                }}
            >
                <img
                    src={`${CHAT_IMAGE_URL}${imageUrl}`}
                    alt="media"
                    style={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        display: 'block',
                        borderRadius: '8px',
                    }}
                />

                {/* Bottom Left: Close Button */}
                <button
                    onClick={onDismiss}
                    style={{
                        position: 'absolute',
                        bottom: '10px',
                        left: '10px',
                        backgroundColor: 'rgba(255, 0, 0, 0.8)',
                        color: 'white',
                        border: 'none',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}
                >
                    Close
                </button>

                {/* Bottom Right: Download Button */}
                <button
                    onClick={handleDownload}
                    style={{
                        position: 'absolute',
                        bottom: '10px',
                        right: '10px',
                        backgroundColor: 'rgba(0, 128, 0, 0.8)',
                        color: 'white',
                        border: 'none',
                        padding: '8px 12px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}
                >
                    Download
                </button>
            </div>
        </div>
    );
}

export default PhotoView;
